import * as Sentry from '@sentry/react';

// Client-Fehler an Sentry. Ohne Consent ist Sentry nicht initialisiert
// (ReactEntry.jsx), captureException tut dann nichts.
export function pushError(topic, exception) {
  try {
    var extra = { topic: topic };

    try {
      var location = window.historyHelper.memory.location;
      extra.reactUrl = location.pathname + location.search;
    } catch {}

    // Ganze apiData waere zu gross fuer ein Sentry-Event
    try {
      if (window.currentPage != undefined) {
        extra.apiRequestUri = window.currentPage.state.apiData.apiRequestUri;
      } else if (window.ctrlBackup != null) {
        extra.reactUrl = window.ctrlBackup.reactUrl;
        extra.apiRequestUri = window.ctrlBackup.apidata.apiRequestUri;
      }
    } catch {}

    if (!(exception instanceof Error)) {
      extra.error = exception;
      exception = new Error(topic);
    }

    Sentry.captureException(exception, {
      tags: { topic: topic },
      extra: extra,
    });
  } catch {}
}
